import CommonServices from "../services/CommonServices";

export default  {
    data() {
        return {
            houseBandRequirements: [
                {id:1, name: 'No'},
                {id:2, name: 'Yes, Band Only'},
                {id:3, name: 'Click Track Only'},
                {id:4, name: 'Can work with band or Click Track'},
            ],
            logisticsShippingRequirements: [
                {id:1, name: 'Carry on'},
                {id:2, name: 'Logistics shipping depends on size/type of show'},
                {id:3, name: 'Logistics shipping'},
                {id:4, name: 'No'},
            ],
            languages: [
                { name: "Arabic",  id: 1 },
                { name: "Chinese (Simplified)", id: 2 },
                { name: "Chinese (Traditional)",  id: 3 },
                { name: "Czech",  id: 4 },
                { name: "Danish",  id: 5 },
                { name: "Dutch", id: 6 },
                { name: "English",  id: 7 },
                { name: "Finnish",  id: 8 },
                { name: "French",  id: 9 },
                { name: "Greek",  id: 10 },
                { name: "German", id: 11 },
                { name: "Georgian",  id: 12 },
                { name: "Hebrew",  id: 13 },
                { name: "Italian",  id: 14 },
                { name: "Japanese",  id: 15 },
                { name: "Korean", id: 16 },
                { name: "Malay", id: 17 },
                { name: "Polish",  id: 18 },
                { name: "Portuguese", id: 19 },
                { name: "Romanian",  id: 20 },
                { name: "Russian",  id: 21 },
                { name: "Spanish", id: 22 },
                { name: "Swedish", id: 23 },
                { name: "Turkish", id: 24 },
                { name: "Vietnamese", id: 25 },
                { name: "Indonesian", id: 26 },
                { name: "Thai",  id: 27 },
                { name: "Hindi",  id: 28 },
                { name: "Bengali",  id: 29 },
                { name: "Tamil",  id: 30 },
                { name: "Punjabi",  id: 31 },
                { name: "Swahili",  id: 32 },
                { name: "Other", id: 33 },
            ]
        }
    },
}
